import React, { useMemo } from "react";
import { Col, Row } from "reactstrap";
import { Component as Form } from "@repoflow/form-schema";
import { useSectionContext } from "@repoflow/components/section";
import * as widgets from "widgets/register";

import { useEditorPage } from "../../context";
import { SharedAcross } from "../../translation";
import { TYPE_FIELD } from "../../element-type";

// What the element IS, rather than what it contains: its type, its name, where
// on the page it lands, and what it is wrapped in.
//
// `name` is not decoration — the composer keys `cxt.elements` by it, so a named
// element is one another element's template can reach.
const CONFIG = {
  "/Page/Element": {
    fields: [
      // Read-only here on purpose. The type selects which branch of `config`
      // the element carries, so changing it after the fact discards whatever
      // was filled in on the tabs beside this one, with nothing on screen
      // saying so. Remove the element and add the right one.
      { property: "type", readOnly: true },
      "name",
      // The slot. "page:header" and "page:footer" are read by the renderer;
      // anything else falls into the body in array order.
      "tags",
      { property: "frame", layout: "wide" },
    ],
  },
};

export const Content = () => {
  const { schema, state } = useSectionContext();
  // Every field on this tab is the group's: the type selects the branch, and
  // the name, the slot and the frame are what the element IS rather than what
  // it says. See ../../translation.
  const { languages } = useEditorPage();

  return (
    <Row>
      <Col>
        <SharedAcross languages={languages} />
        <Form
          schema={schema}
          target={{ $ref: "/Page/Element" }}
          widgets={widgets}
          values={state.values}
          onChange={state.setValues}
          config={CONFIG}
        />
      </Col>
    </Row>
  );
};

// The same form with the type editable, for an element that has none yet —
// there is no per-type tab to put it behind.
export const Only = () => {
  const { schema, state } = useSectionContext();

  const config = useMemo(
    () => ({
      "/Page/Element": {
        // The same configured type field the add dialog uses, and for the same
        // reason — see ../../element-type. This form is the other place the
        // type is editable, so it is the other place that would open showing a
        // type the element does not have.
        fields: [
          TYPE_FIELD,
          "name",
          "tags",
          { property: "frame", layout: "wide" },
        ],
      },
    }),
    []
  );

  return (
    <Row className="mt-3">
      <Col>
        <div className="alert alert-warning">
          This element has no type yet. Choose one to edit its content.
        </div>
        <Form
          schema={schema}
          target={{ $ref: "/Page/Element" }}
          widgets={widgets}
          values={state.values}
          onChange={state.setValues}
          config={config}
        />
      </Col>
    </Row>
  );
};
